module.exports = __webpack_public_path__ + "static/media/bristol-stool-chart.87e5fc34.jpg";